import { render, staticRenderFns } from "./afterSale.vue?vue&type=template&id=54937b8d&scoped=true"
import script from "./afterSale.vue?vue&type=script&lang=js"
export * from "./afterSale.vue?vue&type=script&lang=js"
import style0 from "./afterSale.vue?vue&type=style&index=0&id=54937b8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54937b8d",
  null
  
)

export default component.exports